import { PayloadAction } from '@reduxjs/toolkit'
import { WritableDraft } from 'immer/dist/internal'
import { ECampaignStatus, EDealType } from '@unfoldrtech/portal-mic'
import {
  IDOOHCampaign,
  EDOOHChannelType,
} from '@unfoldrtech/portal-mic/dist/src/openapi/core'

const setDoohCampaignDetails = (
  state: WritableDraft<IDOOHCampaign>,
  action: PayloadAction<{
    channelType: EDOOHChannelType
    title: string
    dealType: EDealType
    status?: ECampaignStatus
  }>
) => {
  state.channelType = action.payload.channelType
  state.title = action.payload.title
  state.dealType = action.payload.dealType
  state.status = action.payload.status
}

export default setDoohCampaignDetails
